import { useFlags } from '@unleash/proxy-client-react';

export enum FeatureToggle {
  BlockFeesSpreadSelection = 'b2bBlockFeesSpreadSelection',
  ShowBasketRedemption = 'b2bShowBasketRedemption',
  Trading = 'b2bShowModuleTrading',
  Customers = 'b2bShowModuleCustomers',
  ReportGenerator = 'b2bShowModuleReportGenerator',
  EquityReportGenerator = 'b2bShowEquityReportGenerator',
  ProfitabilityReportGenerator = 'b2bShowProfitabilityReportGenerator',
  FastTicket = 'b2bShowModuleFastTicket',
  RateManagement = 'b2bShowModuleRateManagement',
  ManagementAnalysis = 'b2bShowModuleManagementAnalysis',
  Home = 'b2bShowModuleHome',
  LegacyHome = 'b2bShowModuleLegacyHome',
  BetaMenuItemManagementAnalysis = 'b2bBetaMenuItemManagementAnalysis',
  BetaMenuItemRateManagement = 'b2bBetaMenuItemRateManagement',
  BetaMenuItemCustomers = 'b2bBetaMenuItemCustomers',
  BetaMenuItemCockpit = 'b2bBetaMenuItemCockpit',
  BetaMenuItemHome = 'b2bBetaMenuItemHome',
  Consortium = 'b2bShowModuleConsortium',
  AdemiconConsortium = 'b2bShowModuleAdemiconConsortium',
  WhatsAppSendingChannelOptionIsEnabled = 'b2bSendingChannelWhatsAppOptionEnabled',
  PushSendingChannelOptionIsEnabled = 'b2bSendingChannelPushOptionEnabled',
  RedemptionSolicitationIsEnabled = 'b2bRedemptionSolicitationEnabled',
  GenialReport = 'b2bShowGenialReport',
  MessageAlertOperatingCostsEquities = 'b2bShowMessageAlertOperatingCostsEquities',
  InviteLink = 'b2bShowInvitationAdvisor',
  Chat = 'b2bShowModuleChat',
  EquityBuySaleOperations = 'b2bShowEquityBuySaleOperations',
  FixedIncomeBuySaleOperations = 'b2bShowFixedIncomeBuySaleOperations',
  DirectTreasuryBuySaleOperations = 'b2bShowDirectTreasuryBuySaleOperations',
  FundBuySaleOperations = 'b2bShowFundBuySaleOperations',
  OrderHistoryEquityActions = 'b2bShowOrderHistoryEquityActions',
  legacyCostumerPosition = 'b2bShowLegacyCostumerPosition',
  NewSubscriptionPage = 'b2bShowNewSubscriptionPage',
  RequireOrderOriginForFixedIncomeBuy = 'b2bRequireOrderOriginForFixedIncomeBuy',
  RequireOrderOriginForFixedIncomeSell = 'b2bRequireOrderOriginForFixedIncomeSell',
  RequireOrderOriginForDirectTreasuryBuy = 'b2bRequireOrderOriginForDirectTreasuryBuy',
  RequireOrderOriginForDirectTreasurySell = 'b2bRequireOrderOriginForDirectTreasurySell',
  RequireOrderOriginForFundsBuy = 'b2bRequireOrderOriginForFundsBuy',
  RequireOrderOriginForFundsSell = 'b2bRequireOrderOriginForFundsSell',
  RequireOrderOriginForEquityBuy = 'b2bRequireOrderOriginForEquityBuy',
  RequireOrderOriginForEquitySell = 'b2bRequireOrderOriginForEquitySell',
  RequireOrderOriginForStructuredOperationsBuy = 'b2bRequireOrderOriginForStructuredOperationsBuy',
  ProductControl = 'b2bShowModuleProductManagement',
  NewAvailableProductsPage = 'b2bShowNewAvailableProductsPage',
  ProfitabilityReportV2 = 'b2bShowProfitabilityReportV2',
  SimplifiedApplication = 'b2bShowSimplifiedApplication',
  ShouldCheckSuitabilityToInvest = 'b2bShouldCheckSuitabilityToInvest',
  FundsOffersV2 = 'b2bEnableFundsOffersV2',
  FixedFee = 'b2bEnableFixedFee',
  SkipSuitabilityCheckForEquity = 'b2bSkipSuitabilityCheckForEquity',
}

export const useUnleashFlags = <T extends string[]>(...flagList: T): Record<T[number], boolean> => {
  const flags = useFlags();

  return flags
    .filter((flag) => flagList.includes(flag.name))
    .map((flag) => ({
      [flag.name]: flag.enabled,
    }))
    .reduce((acc, curr) => ({ ...acc, ...curr }), {}) as Record<T[number], boolean>;
};
